import React from 'react';
import { FormOutlined, RiseOutlined, ShoppingCartOutlined, SyncOutlined } from '@ant-design/icons';

import useMultiLanguageTranslation from 'hooks/useMultiLanguageTranslation';

import { TOrbit } from '../../../i18n/TModules';
import SelectionTile, { TileRow } from '../components/SelectionTile';
import { WizardEntry } from '../components/WizardFrame';
import { IWizardStepProps, nextStep, WizardObjective } from '../wizardModel';

const OBJECTIVES: { objective: WizardObjective; icon: React.ReactNode }[] = [
  { objective: 'sales', icon: <ShoppingCartOutlined /> },
  { objective: 'tasks', icon: <FormOutlined /> },
  { objective: 'habit', icon: <SyncOutlined /> },
  { objective: 'upsell', icon: <RiseOutlined /> }
];

/**
 * 6778:26219, Step 1/5. The campaign module has no objective field, so the answer stays in the
 * wizard: it is neither sent nor reviewed.
 */
const ObjectiveStep: React.FC<IWizardStepProps> = ({ state, update, back }) => {
  const { t } = useMultiLanguageTranslation();
  return (
    <WizardEntry title={t(`${TOrbit}.wizard.objective.title`)} step={1} onBack={back}>
      <TileRow>
        {OBJECTIVES.map(({ objective, icon }) => (
          <SelectionTile
            key={objective}
            icon={icon}
            label={t(`${TOrbit}.wizard.objective.${objective}`)}
            selected={state.objective === objective}
            onSelect={() =>
              update(current => {
                const answered = { ...current, objective };
                return { ...answered, step: nextStep(answered) };
              })
            }
            testId="orbit-wizard-objective-tile"
          />
        ))}
      </TileRow>
    </WizardEntry>
  );
};

export default ObjectiveStep;
